import {Card, FormControl, FormField, Separator} from 'platform/components';
import {VStack, Grid, GridItem} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {SeriesResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';
import {getOptionsFromSeriesList} from '@dms/settings/shared';
import {useDocumentTemplates} from '@dms/shared';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../../../types/WarehouseDirectSaleVariantsDetailFormSchema';

export interface FreeOfChargeCardProps extends TestIdProps {
  control: FormControl<WarehouseDirectSaleVariantsDetailFormSchemaType>;
  formApi: UseFormReturn<WarehouseDirectSaleVariantsDetailFormSchemaType>;
  seriesList: SeriesResponseBody[] | Nullish;
}

export function FreeOfChargeCard(props: FreeOfChargeCardProps) {
  const isPaymentTypeEnabled = useWatch({name: 'documents.internalPayment.isEnable'});

  const [getTemplates] = useDocumentTemplates();
  const {options: invoiceTemplateOptions} = getTemplates('invoice');

  const handlePaymentTypeToggle = (value: boolean) => {
    props.formApi.setValue('documents.internalPayment.isEnable', value);
  };

  return (
    <Card
      title={i18n.t('entity.warehouse.labels.freeOfCharge')}
      variant="inlineGrey"
      isExpanded={isPaymentTypeEnabled}
      control={{
        type: 'switch',
        value: isPaymentTypeEnabled,
        onChange: handlePaymentTypeToggle,
      }}
      data-testid={suffixTestId('card', props)}
    >
      <VStack>
        <Grid columns={2}>
          <GridItem span={1}>
            <FormField
              isRequired={isPaymentTypeEnabled}
              isNotClearable={isPaymentTypeEnabled}
              control={props.control}
              name="documents.internalPayment.invoice.templateId"
              type="choice"
              label={i18n.t('entity.warehouse.labels.invoiceTemplate')}
              options={invoiceTemplateOptions}
              data-testid={suffixTestId('docSeriesId', props)}
            />
          </GridItem>
        </Grid>

        <Separator />

        <Grid columns={2}>
          <GridItem span={1}>
            <FormField
              isRequired={isPaymentTypeEnabled}
              isNotClearable={isPaymentTypeEnabled}
              control={props.control}
              name="documents.internalPayment.invoice.docSeriesId"
              type="choice"
              label={i18n.t('entity.warehouse.labels.invoiceDocumentSerie')}
              options={getOptionsFromSeriesList(props.seriesList, 'accounting/invoice')}
              data-testid={suffixTestId('docSeriesId', props)}
            />
          </GridItem>
          <GridItem span={1}>
            <FormField
              isRequired={isPaymentTypeEnabled}
              isNotClearable={isPaymentTypeEnabled}
              control={props.control}
              name="documents.internalPayment.invoiceCorrection.docSeriesId"
              type="choice"
              label={i18n.t('entity.warehouse.labels.correctiveInvoiceDocumentSerie')}
              options={getOptionsFromSeriesList(props.seriesList, 'accounting/invoice')}
              data-testid={suffixTestId('invoiceTemplateId', props)}
            />
          </GridItem>
        </Grid>
      </VStack>
    </Card>
  );
}
